/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  customValue: {
    type: Array
  },
  disabled: Boolean,
  label: {
    type: [Array, Function],
    "default": function _default() {
      return [];
    }
  },
  loading: Boolean,
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      return ["small", "medium", "large"].includes(val);
    }
  },
  value: {
    type: [String, Number, Boolean],
    "default": false
  },
  defaultValue: {
    type: [String, Number, Boolean],
    "default": false
  },
  onChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
